import styled from 'styled-components/macro';
import { COLORS, Z_INDEX } from 'styleguide';

const SidebarStyled = styled.div`
  position: sticky;
  top: 0;
  z-index: ${Z_INDEX.modal};
  display: flex;
  flex-direction: column;
  height: 100vh;
  text-align: center;
  background-color: transparent;
  border-right: 1px solid ${COLORS.line};
`;

export default SidebarStyled;
